import React from 'react'
import { BoxCenter } from '../../../generic/Box'
import Title from '../../../generic/Title'
import Input from '../../../generic/Input'
import Button from '../../../generic/Button'
import { inject, observer } from 'mobx-react'
import FormRenderer from '../../../generic/FormRenderer'

const XmlSearch = inject('nfeStore')(observer(props => {
  const { nfeStore } = props
  const { searchKey, isSearching } = nfeStore.state
  const formFields = [
    {
      name: 'searchKey',
      type: 'text',
      id: 'nfe-search',
      placeholder: 'Chave do XML',
      value: searchKey,
      handler: event => nfeStore.setSearchKey(event.target.value),
      component: Input
    },
    {
      type: 'submit',
      id: 'nfe-search-submit',
      text: 'Pesquisar',
      component: Button,
      isLoading: isSearching,
      onClick: event => {
        event.preventDefault()
        nfeStore.searchXml()
      }
    }
  ]
  return (
    <BoxCenter>
      <Title>Buscar XML</Title>
      <form>
        <FormRenderer fields={formFields} store={nfeStore} />
      </form>
    </BoxCenter>
  )
}))

export default XmlSearch



// WEBPACK FOOTER //
// ./src/components/dashboard/products/4nfe/XmlSearch.js